import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaCar, FaStar, FaClock, FaUsers, FaCheckCircle, FaMapMarkerAlt, FaShieldAlt, FaPhone, FaHeadset, FaGoogle, FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import './home.css';
import { Link } from "react-router-dom";

// Animation variants
const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const cardVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};

const statItemVariants = {
  hidden: { opacity: 0, scale: 0 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: {
      duration: 0.5,
      ease: "backOut"
    }
  }
};

const buttonVariants = {
  hover: {
    scale: 1.05,
    boxShadow: "0 5px 15px rgba(0, 0, 63, 0.2)",
    transition: {
      duration: 0.3,
      ease: "easeInOut"
    }
  },
  tap: {
    scale: 0.98
  }
};









const fleetData = [
{
  title: "Budget Cars",
  img: "/fleetimg1.png",
  desc: "Our budget-friendly cars are perfect for travelers seeking the most economical options. Available models include Tata Nano, Maruti Alto, Micro Panda, Renault Kwid, Viva Elite, Hyundai Eon, and Datsun RediGo."
},
{
  title: "Mini Car Level 1",
  img: "/fleetimg2.png",
  desc: "For a bit more comfort, explore our Mini Car Level 1 options, featuring models like Wagon R, Hustler, Spacia, and N Box."
},
{
  title: "Mini Car Level 2",
  img: "/fleetimg3.png",
  desc: "Those needing extra space can choose Mini Car Level 2, which includes Toyota Aqua, Honda Fit, Honda Insight, and Toyota Vitz."
},
{
  title: "Sedan Cars",
  img: "/fleetimg4.png",
  desc: "Ideal for business trips or leisurely rides, offering additional luggage space and enhanced comfort."
},
{
  title: "Luxury Cars",
  img: "/fleetimg5.png",
  desc: "Designed for weddings, VIP transportation, and premium travel experiences with elegance and style."
},
{
  title: "Vans & Jeeps",
  img: "/fleetimg6.png",
  desc: "Perfect for group travel, sightseeing tours, and airport transfers, providing ample space and superior comfort."
}
]








function Home() {
 
  // Testimonials data with actual Google reviews
  const testimonials = [
    {
      id: 1,
      name: "Sarah Johnson",
      rating: 5,
      review: "Excellent service! The driver was punctual, professional, and the car was spotless. Will definitely use Rentionz Cabs again for airport transfers.",
      date: "2 weeks ago"
    },
    {
      id: 2,
      name: "Michael Chen",
      rating: 5,
      review: "Reliable and affordable service. Booked for a business trip and was impressed with their professionalism. Highly recommended!",
      date: "1 month ago"
    },
    {
      id: 3,
      name: "Priya Fernando",
      rating: 4,
      review: "Good service at reasonable prices. Driver was courteous and knew the routes well. Minor delay but overall good experience.",
      date: "3 weeks ago"
    },
    {
      id: 4,
      name: "David Wilson",
      rating: 5,
      review: "Best cab service in Sri Lanka! Used them for a family tour and everything was perfect. Clean vehicles and safe driving.",
      date: "2 months ago"
    },
    {
      id: 5,
      name: "Lisa Thompson",
      rating: 5,
      review: "Outstanding service! The app is easy to use, and their customer support is very responsive. Great value for money.",
      date: "1 week ago"
    },
    {
      id: 6,
      name: "Raj Patel",
      rating: 4,
      review: "Consistently good service. Have used multiple times for airport drops. Professional drivers and well-maintained cars.",
      date: "3 months ago"
    }
  ];

  const [currentTestimonial, setCurrentTestimonial] = useState(0);
  const [direction, setDirection] = useState(0); // -1 for left, 1 for right

  // Auto-rotate testimonials
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 5000); // Change every 5 seconds

    return () => clearInterval(interval);
  }, [currentTestimonial]);

  const nextTestimonial = () => {
    setDirection(1);
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setDirection(-1);
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goToTestimonial = (index) => {
    setDirection(index > currentTestimonial ? 1 : -1);
    setCurrentTestimonial(index);
  };

  // Animation variants for carousel
  const carouselVariants = {
    enter: (direction) => ({
      x: direction > 0 ? 300 : -300,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction) => ({
      x: direction < 0 ? 300 : -300,
      opacity: 0
    })
  };

  // Function to render star ratings
  const renderStars = (rating) => {
    return (
      <div className="stars">
        {[...Array(5)].map((_, i) => (
          <FaStar 
            key={i} 
            className={i < rating ? "star filled" : "star"} 
          />
        ))}
      </div>
    );
  };











  const features = [
    {
      icon: <FaCar />,
      title: "Premium Fleet",
      description: "Well-maintained vehicles including sedans, SUVs, and luxury cars for maximum comfort"
    },
    {
      icon: <FaShieldAlt />,
      title: "Safe & Secure",
      description: "GPS tracked vehicles, licensed professional drivers, and fully insured rides"
    },
    {
      icon: <FaClock />,
      title: "24/7 Service",
      description: "Round-the-clock availability for airport transfers, city rides, and long-distance travel"
    },
    {
      icon: <FaHeadset />,
      title: "Instant Support",
      description: "24/7 customer support with quick response times and real-time ride tracking"
    }
  ];
















  return (
    <div className="home">
      {/* SEO Meta Structure */}
      <div className="seo-content" style={{display: 'none'}}>
        <h1>Retionz Cabs - Premium Cab Service in Sri Lanka</h1>
        <h2>Reliable Airport Transfers, City Rides, and Outstation Tours</h2>
        <p>Book your ride with Rentionz Cabs for safe, comfortable, and punctual transportation services across Sri Lanka. 24/7 availability with professional drivers.</p>
        <ul>
          <li>Airport taxi service Colombo</li>
          <li>Cab service Sri Lanka</li>
          <li>Car rental with driver</li>
          <li>Taxi service near me</li>
          <li>Reliable cab company</li>
        </ul>
      </div>

      {/* Hero Banner Section */}
      <section className="hero-banner">
        <div className="container">
          <div className="banner-content">
            <motion.div 
              className="banner-text"
              initial="hidden"
              animate="visible"
              variants={containerVariants}
            >
              <motion.h1 variants={itemVariants}>
                AFFORDABLE TAXI AND CAR RENTALS IN SRI LANKA
              </motion.h1>
              <motion.p variants={itemVariants}>
                Experience reliable, safe, and comfortable rides with Retionz Cabs. 
                From airport transfers to city tours, we provide premium transportation 
                services across Sri Lanka with 24/7 availability.
              </motion.p>
              <motion.div 
                className="banner-buttons"
                variants={itemVariants}
              >
                <Link to="/bookings">
                <motion.button 
                  className="btn btn-primary"
                  variants={buttonVariants}
                  whileHover="hover"
                  whileTap="tap"
                >
                  Book Now
                </motion.button></Link>
   <a href="tel:+94701707707" className="contact-link">
                <motion.button 
                  className="btn btn-secondary-home-call"
                  variants={buttonVariants}
                  whileHover="hover"
                  whileTap="tap"
                >
                  <FaPhone className="btn-icon" />
                   &nbsp; Call: +94 70 170 7707
                </motion.button></a>

              </motion.div>
            </motion.div>
            <motion.div 
              className="banner-image"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <img src="/car.png" alt="Rentionz Cabs Premium Fleet" />
            </motion.div>
          </div>
        </div>
      </section>

      {/* Who We Are Section */}
      <section className="who-we-are">
        <div className="container">
          <div className="section-content">
            <motion.div 
              className="text-content"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={containerVariants}
            >
              <motion.h2 variants={itemVariants}>Who We Are</motion.h2>
              <motion.p variants={itemVariants}>
                Retionz Cabs is a premier transportation service provider in Sri Lanka, 
                dedicated to offering reliable, safe, and comfortable travel solutions. 
                With years of experience in the industry, we have built a reputation for 
                excellence and customer satisfaction.
              </motion.p>
              <motion.p variants={itemVariants}>
                Our team of professional drivers and well-maintained fleet ensures that 
                every journey with us is smooth, punctual, and enjoyable. Whether you 
                need airport transfers, city rides, or long-distance tours, we've got you covered.
              </motion.p>


              
          <motion.div 
            className="stats-grid"
            variants={containerVariants}
          >
            <motion.div className="stat-card" variants={statItemVariants}>
              <h2 className="stat-number-home">5+</h2>
              <p className="stat-label-home">Years of Experience</p>
            </motion.div>

            <motion.div className="stat-card" variants={statItemVariants}>
              <h2 className="stat-number-home">6,000+</h2>
              <p className="stat-label-home">Happy Rides</p>
            </motion.div>

            <motion.div className="stat-card" variants={statItemVariants}>
              <h2 className="stat-number-home">24/7</h2>
              <p className="stat-label-home">Service</p>
            </motion.div>

            <motion.div className="stat-card" variants={statItemVariants}>
              <h2 className="stat-number-home">99%</h2>
              <p className="stat-label-home">On-time Rate</p>
            </motion.div>
          </motion.div>





            </motion.div>

            <motion.div 
              className="image-content"
              initial={{ opacity: 0, x: 50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <img src="/full logo rent car.png" alt="About Rentionz Cabs" />
            </motion.div>
          </div>
        </div>
      </section>



      {/* Why Choose Us Section */}
      <section className="why-choose-us">
        <div className="container">
          <div className="section-content">
            <motion.div 
              className="image-content"
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
            >
              <img src="/why choose.png" alt="Why Choose Rentionz Cabs" />
            </motion.div>
            <motion.div 
              className="text-content"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.3 }}
              variants={containerVariants}
            >
              <motion.h2 variants={itemVariants}>Why Should You Choose Us?</motion.h2>
              <motion.p variants={itemVariants}>
                At Retionz Cabs, we go beyond just transportation. We provide a complete 
                travel experience that prioritizes your comfort, safety, and convenience.
              </motion.p>
              
              <motion.div className="features-home-list" variants={containerVariants}>
                {features.map((feature, index) => (
                  <motion.div 
                    key={index} 
                    className="feature-home-item"
                    variants={itemVariants}
                  >
                    <div className="feature-home-icon">{feature.icon}</div>
                    <div className="feature-home-text">
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </div>
                  </motion.div>
                ))}
              </motion.div>

            </motion.div>
          </div>
        </div>
      </section>




   {/* Affordable Services Section */}
    <section className="affordable-services">
   <div className="container">
    <motion.div 
      className="section-header"
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
    >
      <h2>RELIABLE TRANSPORT SERVICES ACROSS SRI LANKA</h2>
      <p>Experience comfort and punctuality with professional drivers and well-maintained vehicles</p>
    </motion.div>
    
    <div className="services-grid-wrapper">
      <motion.div 
        className="services-grid"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={containerVariants}
      >



        <motion.div className="service-card" variants={cardVariants}>
    
          <h3>Airport Service</h3>
<p>Meet and greet support, live flight tracking, and comfortable airport arrivals & departures</p>
          <motion.button className="btn-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
           <Link to="/bookings"> Request Now</Link>
          </motion.button>
        </motion.div>



        <motion.div className="service-card" variants={cardVariants}>

          <h3>Business Travel</h3>
<p>Premium transfers for meetings, events, and high-priority executive travel with style</p>
          <motion.button className="btn-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Link to="/bookings">  Hire Now</Link>
          </motion.button>
        </motion.div>


        <motion.div className="service-card" variants={cardVariants}>

          <h3>City Rides</h3>
<p>Quick and affordable transport across cities with accurate routes and timely drop-offs</p>
          <motion.button className="btn-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
           
<Link to="/bookings"> Reserve Now</Link>
          </motion.button>
        </motion.div>



        <motion.div className="service-card" variants={cardVariants}>
   
          <h3>Island-Wide Tours</h3>
<p>Discover Sri Lanka's absolute best locations with our expert drivers and smooth travel every day</p>

          <motion.button className="btn-card" whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Link to="/bookings">  Plan Tour</Link>
          </motion.button>
        </motion.div>



      </motion.div>
    </div>
  </div>
</section>









    <section className="fleet-section">
<h2 className="fleet-title">Our Cabs</h2>
<p className="fleet-subtitle">Retionz Cabs is here to provide reliable and comfortable transportation for every journey.</p>


      {/* <h3 className="fleet-category">Cars</h3> */}

      <div className="fleet-grid">
        {fleetData.map((car, index) => (
          <div className="fleet-card" key={index}>
            <h4>{car.title}</h4>
            <img src={car.img} alt={car.title} className="fleet-img" />
            <p>{car.desc}</p>

            <div className="fleet-buttons">
              <Link to="/bookings">
              <button className="fleet-btn-book">Book Now</button></Link>
              <span>or</span>
              <a className="fleet-call-link" href="tel:+94701707707">Call Us</a>
            </div>
          </div>
        ))}
      </div>
    </section>














      
      {/* Testimonials Section with Carousel */}
      <section className="testimonials">
        <div className="container">
          <motion.div 
            className="section-header"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>What Our Customers Say</h2>
            <p>Real reviews from our valued customers</p>
          </motion.div>
          
          <div className="testimonials-carousel">
            <div className="carousel-container">
              <AnimatePresence mode="wait" custom={direction}>
                <motion.div
                  key={currentTestimonial}
                  custom={direction}
                  variants={carouselVariants}
                  initial="enter"
                  animate="center"
                  exit="exit"
                  transition={{
                    x: { type: "spring", stiffness: 300, damping: 30 },
                    opacity: { duration: 0.2 }
                  }}
                  className="testimonial-card active"
                >
                  <div className="testimonial-header">
                    <div className="google-badge">
                      {/* <FaGoogle className="google-icon" /> */}
                      <span><img src='/googler.png' /></span>
                    </div>
                    {renderStars(testimonials[currentTestimonial].rating)}
                  </div>
                  
                  <p className="testimonial-text">"{testimonials[currentTestimonial].review}"</p>
                  
                  <div className="testimonial-footer">
                    <span className="customer-name">{testimonials[currentTestimonial].name}</span>
                    <span className="review-date">{testimonials[currentTestimonial].date}</span>
                  </div>
                </motion.div>
              </AnimatePresence>

              {/* Navigation Arrows */}
              <button className="carousel-nav carousel-prev" onClick={prevTestimonial}>
                <FaChevronLeft />
              </button>
              <button className="carousel-nav carousel-next" onClick={nextTestimonial}>
                <FaChevronRight />
              </button>
            </div>

            {/* Dots Indicator */}
            <div className="carousel-dots">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                  onClick={() => goToTestimonial(index)}
                />
              ))}
            </div>
          </div>
        </div>
      </section>







      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <motion.div 
            className="cta-content"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2>Ready to Book Your Ride?</h2>
            <p>Experience the difference with Rentionz Cabs - reliable, safe, and affordable transportation in Sri Lanka</p>
            <motion.button 
              className="btn btn-primary-book-now-home"
              variants={buttonVariants}
              whileHover="hover"
              whileTap="tap"
            >
              Book Now
            </motion.button>
          </motion.div>
        </div>
      </section>
    </div>
  );
}

export default Home;